/** Map Hair Insight dashboard microscope + coverage to recommender scores (no rule-text guessing). */

function severityToConcernScore(severity) {
  const s = String(severity || '').toLowerCase().replace(/_/g, ' ');
  if (s === 'high' || s === 'severe') return 32;
  if (s === 'moderate') return 48;
  if (s === 'mild') return 62;
  return 72;
}

function setScore(scores, detected, label, value) {
  const score = severityToConcernScore(value);
  if (!detected.includes(label)) detected.push(label);
  scores[label] = Math.min(scores[label] ?? 100, score);
}

export function buildInsightConditionScores(dashboard) {
  const scores = {};
  const detected = [];
  const regions = dashboard?.coverageMap?.regions || {};

  Object.values(regions).forEach((region) => {
    if (!region || typeof region !== 'object') return;
    const thin = region.thinningAppearance || region.thinning;
    if (thin && !['low', 'none', 'not_assessable', ''].includes(String(thin).toLowerCase())) {
      setScore(scores, detected, 'Thinning Stage 2', thin);
    }
  });

  const micro =
    dashboard?.normalized?.microscope ||
    dashboard?.scalpInsight?.microscope ||
    dashboard?.scalpInsight ||
    {};
  Object.entries(micro).forEach(([key, node]) => {
    const raw = typeof node === 'object' ? node.value ?? node.display : node;
    const v = String(raw || '').toLowerCase();
    if (!v || v === 'low' || v === 'none_visible' || v === 'not_assessable') return;
    if (key === 'flaking' || key === 'scaling') {
      setScore(scores, detected, 'Dandruff', v);
    }
    if (key === 'oiliness' || key === 'greasy') {
      setScore(scores, detected, 'Greasy Hair', v);
    }
    if (key === 'rednessAppearance' || key === 'scalpRash') {
      setScore(scores, detected, 'Scalp Rash', v);
    }
  });

  const hair = dashboard?.hairCondition || {};
  const density = hair.density?.value || hair.density;
  if (density && ['low', 'sparse', 'thin'].includes(String(density).toLowerCase())) {
    setScore(scores, detected, 'Thinning Stage 2', 'moderate');
  }

  return { condition_scores: scores, detected_conditions: detected };
}
